import { getDewarProductTypeList } from "../../../services/requests";
import { FormItemType } from "../../UI/view/component-map";
import { ListViewColumnType } from "../../UI/view/list-view";

type DewarProductTypeOption = {
  id?: number | null;
  Id?: number | null;
  productNumber?: string | null;
  ProductNumber?: string | null;
  isActive?: boolean | null;
  IsActive?: boolean | null;
  isInactive?: boolean | null;
  IsInactive?: boolean | null;
};

const getDewarProductTypeNumber = (productType: DewarProductTypeOption) => {
  return productType.productNumber ?? productType.ProductNumber ?? '';
};

const isDewarProductTypeActive = (productType: DewarProductTypeOption) => {
  if (typeof productType.isActive === 'boolean') {
    return productType.isActive;
  }

  if (typeof productType.IsActive === 'boolean') {
    return productType.IsActive;
  }

  if (typeof productType.isInactive === 'boolean') {
    return !productType.isInactive;
  }

  if (typeof productType.IsInactive === 'boolean') {
    return !productType.IsInactive;
  }

  return false;
};

const getDewarProductTypeId = (productType: DewarProductTypeOption) => {
  return productType.id ?? productType.Id ?? null;
};

export const dewarLineInfoEditTable = {
  name: 'locationDewarLineInfo',
  type: FormItemType.editTable,
  pk: 'id',
  columns: [
    {
      type: ListViewColumnType.delete,
      accessor: 'delete',
    },
   
    {
      accessor: 'dewarProductTypeId',
      Header: 'Dewar Product Type',
      fixedWidth: 260,
      formItemProps: {
        name: 'dewarProductTypeId',
        required: true,
        defaultValue: null,
        type: FormItemType.select,
        options: async () => {
          const results = await getDewarProductTypeList();
          const list = ((results || []) as DewarProductTypeOption[])
            .filter((productType) => isDewarProductTypeActive(productType) && /^HELT/i.test(getDewarProductTypeNumber(productType)))
            .sort((left, right) => getDewarProductTypeNumber(left).localeCompare(getDewarProductTypeNumber(right)))
            .map((productType) => ({ id: getDewarProductTypeId(productType), text: getDewarProductTypeNumber(productType) }));
          return [{ id: null, text: '-- Select --' }, ...list];
        }
      }
    },
    {
      accessor: 'dewarReserve',
      Header: 'Dewar Reserve',
      formItemProps: {
        name: 'dewarReserve',
        required: true,
        defaultValue: 0,
        number: true
      }
    },
    {
      accessor: 'hoursToStabilize',
      Header: 'Hours To Stabilize',
      formItemProps: {
        name: 'hoursToStabilize',
        required: true,
        defaultValue: 0,
        number: true
      }
    },
    {
      accessor: 'cooldownDays',
      Header: 'Cooldown Days',
      formItemProps: {
        name: 'cooldownDays',
        required: true,
        defaultValue: 0,
        number: true
      }
    },
  ]
};
